import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import Paper from '../../../paper/paper'
import TabNav from './tab-nav/tab-nav.container'
import SharedContainer from './shared/shared.container'
import { Route } from 'react-router-dom'
import MyLessons from './my-lessons/my-lessons.container'

const styles = {
  paper: {
    minHeight: 'calc(100vh - 230px)',
    margin: '-20px',
    borderRadius: '0',
    borderTop: '1px solid #ececec',
    paddingBottom: '80px',
    '@media (min-width: 768px)': {
      margin: '0',
      borderRadius: '8px',
      paddingBottom: '22px',
      border: 'none'
    }
  },
  tabContainer: {
    padding: '30px 0 0'
  }
}

const Lessons = ({ classes, onMount }) => {
  useEffect(() => {
    onMount()
  }, []) // eslint-disable-line

  return (
    <Paper className={classes.paper}>
      <TabNav />
      <div className={classes.tabContainer}>
        <Route exact path={['/', '/new']} component={MyLessons} />
        <Route path="/shared" component={SharedContainer} />
      </div>
    </Paper>
  )
}

export default injectSheet(styles)(Lessons)
